import { createContext } from "react";
import { getInitialAppState } from "../init";

const AppStateContext = createContext(getInitialAppState([], null));

export default AppStateContext;
